module.exports = __webpack_public_path__ + "img/breadcrumb-icon.352b024c.svg";